import React from 'react';
import classes from './FullScreen.module.css'

const FullScreen = props => {
    return (
        <div 
            className={classes.fullScreen} 
            style={props.style}
            onMouseDown={props.onMouseDown}
            onMouseUp={props.onMouseUp}
            onMouseMove={props.onMouseMove}
        >
            {props.children}
        </div>
    )
}

export default FullScreen;
